import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/Bg-and-dubai.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                A Top-Tier Android App Development Company in Dubai for Your
                Next Project
              </h2>
            </div>
            <p>
              We are the best place for you to get a high-quality Android app
              developed in Dubai. Our team of talented Android app developers is
              committed to offering original, custom-made solutions that are
              especially created for the Dubai market. As a top Android app
              development company in Dubai, we take great satisfaction in our
              commitment to app quality, which is demonstrated by each project
              we work on.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
